import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

import type { CarouselItem, ListContext } from 'renderer/utils/analytics';
import { buildEvent, findItem } from 'renderer/utils/analytics';

export const useTrolleyAnalytics = (items: CarouselItem[], listContext?: ListContext) => {
  const { trackEvent } = useAnalytics();

  const trackAdd = (quantity: number, lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('add_to_cart', found.item, found.index, listContext, quantity));
  };

  const trackRemove = (quantity: number, lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('remove_from_cart', found.item, found.index, listContext, quantity));
  };

  return { trackAdd, trackRemove };
};
